module.exports = __webpack_public_path__ + "static/media/db3.71de2515.jpg";